/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { socialGetSocialBilibiliLiveroom } from "../../funcs/socialGetSocialBilibiliLiveroom.js";
import { GetSocialBilibiliLiveroomRequest$zodSchema } from "../../models/getsocialbilibililiveroomop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetSocialBilibiliLiveroomRequest$zodSchema.optional(),
};

export const tool$socialGetSocialBilibiliLiveroom: ToolDefinition<typeof args> =
  {
    name: "social-get-social-bilibili-liveroom",
    description: `查询 B站直播间

想知道你喜欢的主播开播了吗？或者想在你的应用里集成B站直播间状态？这个接口能满足你。

## 功能概述
这是一个智能接口，你可以用主播的 \`mid\` (用户ID) 或者直播间的 \`room_id\` (长号或短号)来查询。它会返回直播间的详细信息，包括是否在直播、标题、封面、人气、分区等。

## 响应体字段说明
- **\`live_status\` (直播状态)**: \`0\` 代表未开播，\`1\` 代表直播中，\`2\` 代表轮播中。`,
    scopes: ["read"],
    annotations: {
      "title": "",
      "destructiveHint": false,
      "idempotentHint": false,
      "openWorldHint": true,
      "readOnlyHint": true,
    },
    args,
    tool: async (client, args, ctx) => {
      const [result] = await socialGetSocialBilibiliLiveroom(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      return formatResult(result.value);
    },
  };
